module.exports = __webpack_public_path__ + "images/REFER_AND_EARN_LADY_IMAGE_2091024.png";